import { createActions } from '../utils/actions';

const { actions: data } = createActions('data')
  .add('addProductType')
  .add('addSection')
  .addAsync('addVariations')
  .add('addVendor')
  .addAsync('deleteVariations')
  .add('getAllData')
  .addAsync('getChannelData')
  .addAsync('getProfiles')
  .addAsync('getShopData')
  .addAsync('getVariations')
  .add('setData');

export default data;
